import axios from 'axios';

import {
    KYB_API_BASE_URL
} from '../../../../constants/index';

export default class ComplianceScreeningQueryItemService {
    static instance;
    resource = `${KYB_API_BASE_URL}/kyb/compliance-screening/query/item`;

    static getInstance() {
        if (!ComplianceScreeningQueryItemService.instance) {
            ComplianceScreeningQueryItemService.instance = new ComplianceScreeningQueryItemService();
        }

        return ComplianceScreeningQueryItemService.instance;
    }

    async toggleActiveStatus(itemId, payload) {
        const response = await axios.post(
            `${this.resource}/${itemId}/toggle-active`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data;
    }
}
